import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body text-center py-4" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = { class: "card-body py-5" }
const _hoisted_7 = { class: "m-0" }
const _hoisted_8 = { class: "card information" }
const _hoisted_9 = { class: "card-body p-4" }
const _hoisted_10 = { class: "m-0" }
const _hoisted_11 = { class: "m-0" }
const _hoisted_12 = { class: "d-flex w-100 py-4 border-bottom border-top mt-4" }
const _hoisted_13 = { class: "w-50" }
const _hoisted_14 = { class: "m-0" }
const _hoisted_15 = { class: "w-50" }
const _hoisted_16 = { class: "m-0" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = {
  key: 0,
  class: "col-5 border-end"
}
const _hoisted_19 = { class: "m-0" }
const _hoisted_20 = { class: "col ps-4" }
const _hoisted_21 = { class: "m-0 mt-3" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_qrcode = _resolveComponent("vue-qrcode")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.logo)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.logo
            }, null, 8, _hoisted_3))
          : _createCommentVNode("", true),
        (!_ctx.logo)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_4, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.ticket.event?.title), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_vue_qrcode, {
          ref: "qrcode",
          value: _ctx.ticket?._id,
          options: _ctx.options,
          class: "mt-3"
        }, null, 8, ["value", "options"]),
        _createElementVNode("p", _hoisted_7, [
          _createElementVNode("small", null, _toDisplayString(_ctx.ticket?._id), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("p", _hoisted_10, [
          _createElementVNode("small", null, _toDisplayString(_ctx.ticket.first_name ? "Nombre:" : "Usuario:"), 1)
        ]),
        _createElementVNode("h3", _hoisted_11, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.ticket.first_name
            ? `${_ctx.ticket.first_name}
                                ${_ctx.ticket.last_name}`
            : _ctx.ticket.username), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _cache[0] || (_cache[0] = _createElementVNode("p", { class: "m-0" }, [
              _createElementVNode("small", null, "Tipo:"),
              _createElementVNode("br")
            ], -1)),
            _createElementVNode("h4", _hoisted_14, _toDisplayString(_ctx.ticket.option.name), 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _cache[1] || (_cache[1] = _createElementVNode("p", { class: "m-0" }, [
              _createElementVNode("small", null, "Evento:"),
              _createElementVNode("br")
            ], -1)),
            _createElementVNode("h4", _hoisted_16, _toDisplayString(_ctx.ticket.event?.title), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          (_ctx.ticket.event?.date?.start)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _cache[3] || (_cache[3] = _createElementVNode("p", { class: "m-0 mt-3" }, [
                  _createElementVNode("small", null, "Fecha:")
                ], -1)),
                _createElementVNode("h4", _hoisted_19, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.date(_ctx.ticket.event?.date?.start).split("|")[0]), 1),
                  _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.date(_ctx.ticket.event?.date?.start).split("|")[1]), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("p", _hoisted_21, [
              _cache[7] || (_cache[7] = _createElementVNode("small", null, "Lugar:", -1)),
              _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
              (_ctx.ticket.event?.location.type == 'place')
                ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.ticket.event?.location.address.name), 1),
                    _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
                    _createElementVNode("small", null, [
                      _createTextVNode(_toDisplayString(_ctx.ticket.event?.location.address.address_1) + " " + _toDisplayString(_ctx.ticket.event?.location.address.address_2), 1),
                      _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.ticket.event?.location.address.city) + ", " + _toDisplayString(_ctx.ticket.event?.location.address.state) + ", " + _toDisplayString(_ctx.ticket.event?.location.address.zip) + ", " + _toDisplayString(_ctx.ticket.event?.location.address.country), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.ticket.event?.location.type == 'to-be-announced')
                ? (_openBlock(), _createElementBlock("span", _hoisted_23, [...(_cache[6] || (_cache[6] = [
                    _createElementVNode("strong", null, "El lugar del evento aún no ha sido asignado.", -1)
                  ]))]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ], 64))
}